import styled, { css } from 'styled-components';
import { AbstractPopup } from './AbstractPopup';
import { PopupCssPreset } from './Popup.styles';
export const PurchasePopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Center};
    --Popup_Width: 25rem;
    --Popup_Padding: 0;

    /* Product catalog */
    --ProductCatalogPlate_ProductListPadding: 0 1.5rem;
    --ProductCatalogPlate_ProductListMaxHeight: min(
        calc(
            var(--vh-100, 100vh) - 5.5rem - 2 *
                var(--Popup_BoundingBoxPadding, 1rem)
        ),
        17.25rem
    );

    --PurchaseCustomization_ContentMaxHeight: calc(
        var(--vh-100, 100vh) - 3rem - 2 * var(--Popup_BoundingBoxPadding, 1rem)
    );

    @media (min-width: 60rem) {
        ${({ $alignToSidebar = false }) => $alignToSidebar &&
    css `
                --Popup_BorderRadius: var(--tv-ui-border-radius-3);
                --Popup_Width: calc(var(--Sidebar_DesktopWidth) - 1.5rem);
                --Popup_X: calc(var(--vw, 1vw) * 100 - 100% - 1.5rem);
                --Popup_Y: max(
                    4.25rem,
                    calc(var(--Popup_AnchorY, 0) - 100% + 1px)
                );

                /* Product catalog */
                --ProductCatalogPlate_ProductListMaxHeight: min(
                    calc(var(--Popup_AnchorY, 0) - 4.25rem - 5.5rem),
                    17.25rem
                );

                --PurchaseCustomization_ContentMaxHeight: calc(
                    var(--Popup_AnchorY, 0) - 4.25rem - 3rem
                );
            `}
    }
`;
